import React from 'react';
import { connect } from 'react-redux';

import { REDUCER_NAME } from 'src/reducers/clients/allowances';
import { REDUCER_NAME as PAYROLL_RULES_GROUP_REDUCER_NAME } from 'src/reducers/clients/payrollRulesGroups';
import { setList } from 'src/reducers/common/listReducer';
import { setItem } from 'src/reducers/common/itemReducer';
import ClientAllowancesTable from './components/ClientAllowancesTable';

const ClientAllowancesList = ({ dispatch, clientAllowances, payrollRulesGroup }) => {
  dispatch(setList(REDUCER_NAME, { data: clientAllowances }));
  dispatch(setItem(PAYROLL_RULES_GROUP_REDUCER_NAME, payrollRulesGroup));
  return <ClientAllowancesTable payrollRulesGroup={payrollRulesGroup} />;
};

export default connect()(ClientAllowancesList);
